import logo from "./assets/n.png";
import "./App.css";
import React from "react";
import Parse from "./Parse";

const App = () => {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div>
          <h1>List Generator</h1>
        </div>
        <Parse />
      </header>
    </div>
  );
};

export default App;
